module.exports = __webpack_public_path__ + "img/Foto_Tiziana_2.200ae8ee.jpg";